var React = require('react');

function ChevronLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.327 8l4.787 4.702-1.401 1.426-5.514-5.415a1 1 0 0 1 0-1.426l5.514-5.415 1.401 1.426L6.327 8z","fill":"currentColor"}));
}

ChevronLeftInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = ChevronLeftInline;

ChevronLeftInline.default = ChevronLeftInline;
